import React, { useEffect, useState } from "react";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { useDispatch, useSelector } from "react-redux";
import { modulosStartLoad } from "../../../actions/usuario";
import { ModuloTable } from "./ModuloTable";
import { ModuloModal } from "./modal/ModuloModal";
import { RutaScreen } from "../ruta/RutaScreen";

const LoadModulos = (dispatch) => dispatch(modulosStartLoad());
export const ModuloListScreen = ({ handleOpenRutaForm }) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const handleReload = () => LoadModulos(dispatch);
  const { modulos } = useSelector((state) => state.usuario);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  return (
    <PageHeaderUi
      title="Modulos"
      subTitle="Listado"
      extra={[
        <ButtonUi
          typeUi={TipoButtonConstants.Actualizar}
          key="actualizar"
          onClick={handleReload}
        />,
        <ButtonUi
          typeUi={TipoButtonConstants.Nuevo}
          key="Nuevo"
          onClick={handleOpenModal}
        />,
      ]}
    >
      <ModuloTable
        modulos={modulos}
        handleOpenModal={handleOpenModal}
        handleOpenRutaForm={handleOpenRutaForm}
      />
      <ModuloModal open={openModal} handleCloseModal={handleCloseModal} />
    </PageHeaderUi>
  );
};
export const ModuloList = () => {
  const dispatch = useDispatch();
  const [openRutaForm, setOpenRutaForm] = useState(false);
  const handleOpenRutaForm = () => setOpenRutaForm(true);
  const handleCloseRutaForm = () => setOpenRutaForm(false);
  useEffect(() => {
    LoadModulos(dispatch);
  }, []);
  if (openRutaForm)
    return (
      <RutaScreen
        openForm={openRutaForm}
        HandleCloseForm={handleCloseRutaForm}
      />
    );
  else return <ModuloListScreen handleOpenRutaForm={handleOpenRutaForm} />;
};
export default ModuloList;
